import CreateJob from './CreateJob-view';

export default CreateJob;
